require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./post-top-5-programming-books.json") })
        }
      }, "path---post-top-5-programming-books");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---post-top-5-programming-books!./.cache/json/post-top-5-programming-books.json
// module id = 358
// module chunks = 231608221292675